'use client';

import { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import ErrorBoundary from '@/components/common/ErrorBoundary';
import AppRouter from '@/views/AppRouter';

const CompareBar = dynamic(() => import('@/components/common/CompareBar'), {
  ssr: false,
  loading: () => null,
});

export default function MainLayout({ children = null }) {
  const hasInitialPageContent = children !== null;
  const [showAppRouter, setShowAppRouter] = useState(!hasInitialPageContent);
  const eagerRouter = hasInitialPageContent && showAppRouter;

  useEffect(() => {
    if (!hasInitialPageContent) return;
    setShowAppRouter(true);
  }, [hasInitialPageContent]);

  return (
    <>
      <a href="#main-content" className="skip-to-content">Skip to main content</a>
      <Header />
      <ErrorBoundary>
        <main id="main-content">
          {showAppRouter ? <AppRouter eager={eagerRouter} /> : children}
        </main>
      </ErrorBoundary>
      <CompareBar />
      <Footer />
    </>
  );
}
